import { Icon, IconProps } from "@chakra-ui/react";

const BackIcon = (
  props: IconProps = {
    color: "neutral500",
    strokeWidth: ".15rem",
    _hover: { color: "primary400" },
  }
) => {
  return (
    <Icon
      viewBox="0 0 9 16"
      {...props}
      _dark={{ color: "neutral300", _hover: { color: "primary200" } }}
    >
      <path
        d="M7.5 1.75L1.25 8L7.5 14.25"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </Icon>
  );
};

export default BackIcon;
